import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v1/brands', { params });
  },
  detail(id) {
    return axios.get(`/v1/brands/${id}`);
  },
  update(id, params) {
    return axios.put(`/v1/brands/${id}`, params);
  },
  create(data) {
    return axios.post('/v1/brands', data);
  },
  delete(id) {
    return axios.delete(`/v1/brands/${id}`);
  }
};
